import {Fragment} from 'react';

import './styles.scss';

type Props = {
  name?: string;
  image?: string;
};

const USER_NOT_ASSIGNED = 'not assigned';

// Work with image property will be changed after clarifying what data will be provided
export const UserPreview: React.FC<Readonly<Props>> = ({name}: Readonly<Props>) => (
    <div className='vs-user-preview'>
        {name ? (
            <Fragment>
                {/* TODO Commented until functionality will be implemented  */}
                {/* <img className='user-preview__image' src={image} alt=''/> */}
                <span className='user-name'>{name}</span>
                {' '}
            </Fragment>
        ) : (
            <span className='user-name'>{USER_NOT_ASSIGNED}</span>
        )}
    </div>
);
